import { render, staticRenderFns } from "./DocumentUploadPopup.vue?vue&type=template&id=17d9bec4"
import script from "./DocumentUploadPopup.vue?vue&type=script&lang=js"
export * from "./DocumentUploadPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports